import React from 'react';
import ipad from './ipad-3column.png';


const HeroImage = () => (
  <img src={ipad} />
);

export default HeroImage;
